/**
 * Welcome tour — first-login shell + module orientation.
 * Steps with requirePermission / requireFlag are filtered at runtime.
 */

export const WELCOME_TOUR_ID = "welcome";

export const WELCOME_TOUR_STEPS = [
  {
    id: "welcome",
    route: "/home",
    title: "Welcome to ROS",
    description:
      "This is your Resolute Operating System — the place to find federal opportunities, stay on top of intelligence, and get work done with your team. This short tour shows where everything lives.",
    placement: "center",
  },
  {
    id: "sidebar",
    route: "/home",
    selector: "[data-tour='sidebar']",
    title: "Your navigation",
    description:
      "The left sidebar is how you move around ROS. Modules are grouped here so you can jump straight to Growth, Intelligence, People, and more.",
    placement: "right",
  },
  {
    id: "nav-dashboard",
    route: "/home",
    selector: "[data-tour='nav-dashboard']",
    title: "Dashboard",
    description:
      "Start your day here. Dashboard is your home base — open it anytime to see what needs attention.",
    placement: "right",
  },
  {
    id: "dashboard-home",
    route: "/home",
    selector: "[data-tour='dashboard-home']",
    title: "Your daily pulse",
    description:
      "Tasks, pipeline health, response deadlines, and fresh intelligence land in one view. Check this when you want a quick sense of the day before diving into a module.",
    placement: "bottom",
  },
  {
    id: "nav-growth",
    route: "/home",
    selector: "[data-tour='nav-growth']",
    title: "Growth",
    description:
      "Growth is where federal leads and opportunities live — triage, pipeline, marketing responses, and more. Open this when you are hunting or qualifying work.",
    placement: "right",
    expandSection: "growth",
    requireFlag: "module.growth",
  },
  {
    id: "triage",
    route: "/triage",
    selector: "[data-tour='triage-board']",
    title: "Lead Triage",
    description:
      "This queue is for fast go / no-go decisions on scored solicitations. Use it when you need to clear overnight intake or move promising leads forward.",
    placement: "bottom",
    expandSection: "growth",
    requirePermission: "leads.view",
    requireFlag: "module.growth",
  },
  {
    id: "nav-intelligence",
    route: "/home",
    selector: "[data-tour='nav-intelligence']",
    title: "Intelligence",
    description:
      "Intelligence gathers market and competitive signal — briefs, fusion views, and research. Come here when you need context before a capture decision.",
    placement: "right",
    expandSection: "intelligence",
    requireFlag: "module.osint_lake",
  },
  {
    id: "intel-home",
    route: "/intel",
    selector: "[data-tour='intel-home']",
    title: "Intel Fusion Center",
    description:
      "A living picture of what matters across agencies and competitors. Open it when you want the latest compiled intelligence without digging through every source.",
    placement: "bottom",
    expandSection: "intelligence",
    requirePermission: "intel.view",
    requireFlag: "module.osint_lake",
  },
  {
    id: "nav-people",
    route: "/home",
    selector: "[data-tour='nav-people']",
    title: "People",
    description:
      "People covers leave, time, approvals, and performance tools for everyday use. HR and T&A tools live in the separate People Admin section.",
    placement: "right",
    expandSection: "people",
    requireFlag: "module.people",
  },
  {
    id: "nav-ta-dashboard",
    route: "/home",
    selector: "[data-tour='nav-ta-dashboard']",
    title: "Time & Attendance — Dashboard",
    description:
      "Your T&A home: today’s hours, missed logs, and leave balances. Open this first each workday.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-ta-leave",
    route: "/home",
    selector: "[data-tour='nav-ta-leave']",
    title: "Leave",
    description:
      "Request time off and check Available, Booked, and Taken balances.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-ta-time",
    route: "/home",
    selector: "[data-tour='nav-ta-time']",
    title: "Time",
    description:
      "Log weekly hours by job, certify pay periods, and download timesheet PDFs.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-ai-hub",
    route: "/home",
    selector: "[data-tour='nav-ai_hub']",
    title: "AI Hub",
    description:
      "Chat with Resolute's AI assistants, capture focus notes, and work with documents. Open Hub when you need a thinking partner mid-task.",
    placement: "right",
    expandSection: "ai_hub",
    requireFlag: "module.ai_hub",
  },
  {
    id: "hub-home",
    route: "/hub",
    selector: "[data-tour='hub-home']",
    title: "Start a conversation",
    description:
      "Pick or start a chat, switch models, and keep context for the work in front of you. Typical use: draft notes, summarize a lead, or unblock a question quickly.",
    placement: "right",
    expandSection: "ai_hub",
    requirePermission: "ai_hub.view",
    requireFlag: "module.ai_hub",
  },
  {
    id: "header-actions",
    route: "/home",
    selector: "[data-tour='header-actions']",
    title: "Account & alerts",
    description:
      "Notifications, theme, and your account menu live up here. Check the bell when something is assigned or due.",
    placement: "bottom",
  },
  {
    id: "nav-help",
    route: "/help",
    selector: "[data-tour='nav-help']",
    title: "Help is always here",
    description:
      "Detailed how-tos live on the Help page. You can also restart this product tour anytime from Help if you want a refresher.",
    placement: "right",
  },
  {
    id: "finish",
    route: "/help",
    selector: "[data-tour='help-restart-tour']",
    title: "You're ready",
    description:
      "That's the map of ROS. Explore at your pace — and tap Restart product tour here whenever you want this walkthrough again.",
    placement: "bottom",
  },
];
